export const CPK_DEFAULT_Y_TICKS: number[] = [10, 8, 6, 4, 2, 0];

export const CPK_TICK_INTERVALS: number = 5;

// Cost per km is usually a few currency units, so whole-number ticks would repeat
export const CPK_TICK_DECIMALS: number = 2;
